import { Expose, Transform, Type } from 'class-transformer';
import { UserEntity } from '@core/entities/user.entity';
import { SafeUrl } from '@angular/platform-browser';
import { InitializableEntity } from '@core/entities/_extra/intializable.entity';

export class WorkShiftEntity extends InitializableEntity {
  id: number;

  @Expose({ name: 'event_id' })
  eventId: number;

  title = '';
  date = new Date().toDateString();
  description = '';

  @Expose({ name: 'start_time' })
  startTime = '';

  @Expose({ name: 'end_time' })
  endTime = '';

  upload: string | string[];

  @Transform(({ value }) => +value || 0)
  author: number;

  //  We need to get users from shiftAssign property from backend and transform into shiftUsers
  @Type(() => UserEntity)
  shiftUsers: UserEntity[];

  // For UI purpose
  imageUrl: SafeUrl;

  // For POST/PUT request

  desc = '';

  @Expose({ name: 'shift_assign_user' })
  @Type(() => UserEntity)
  shiftAssignUser: UserEntity[] = [];
  image: File;

  @Type(() => ShiftAssignEntity)
  shiftAssign: ShiftAssignEntity[];

  constructor(values?: Partial<WorkShiftEntity>) {
    super();
    this.initEntity(values);
  }
}

class ShiftAssignEntity {
  @Expose({ name: 'shift_id' })
  shiftId: number;

  @Expose({ name: 'user_id' })
  userId: number;

  @Type(() => UserEntity)
  user: UserEntity;
}
